import React, { useState, useEffect } from 'react';
import { Link, useNavigate, Outlet } from 'react-router-dom';
import { FaShoppingBag, FaSearch, FaCoins } from 'react-icons/fa'; 
import { CiDeliveryTruck, CiHeart } from "react-icons/ci";
import { MdOutlineAccountCircle } from "react-icons/md";
import { TbLogout } from "react-icons/tb";
import TopBar from './Topbar'
import xianheLogo from '../Components/Assets/XianheLogo.png'


const MasterLayout= () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [username, setUsername] = useState('');
    const [coins, setCoins] = useState(0); 
    const [comcoins, setComCoins] = useState(0); 
    const [panelVisible, setPanelVisible] = useState(false); 
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const checkLogin = () => {
            const loggedIn = localStorage.getItem('isLoggedIn') === 'true';
            setIsLoggedIn(loggedIn);
            if (loggedIn) {
                setUsername(localStorage.getItem('username') || 'User');
                setCoins(Number(localStorage.getItem('coins')) || 0);
                setComCoins(Number(localStorage.getItem('comcoins')) || 0);
            }
        };
    
        checkLogin();
    
        const handleResize = () => {
            const minWidth = window.innerWidth * 0.25;
            const minHeight = window.innerHeight * 0.25;
            if (window.innerWidth < minWidth) {
                window.resizeTo(minWidth, window.innerHeight);
            }
            if (window.innerHeight < minHeight) {
                window.resizeTo(window.innerWidth, minHeight);
            }
        };
    
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    //mobile device
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
      const handleResize = () => {
        // Set isMobile to true if screen width is less than 768px (common breakpoint)
        setIsMobile(window.innerWidth < 768);
      };

      // Check initially and also on resize
      handleResize();
      window.addEventListener("resize", handleResize);

      // Clean up the event listener
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    
    const handleLogout = () => {
    // Clear all user-related localStorage keys to avoid stale state
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('userID');
    localStorage.removeItem('username');
    localStorage.removeItem('name');
    localStorage.removeItem('password');
    localStorage.removeItem('roletype');
    localStorage.removeItem('coins');
    localStorage.removeItem('comcoins');
    setIsLoggedIn(false);
    setUsername('');
    setCoins(0);
    setComCoins(0);
    navigate('/main');
    };

    const handleAddCoins = (amount) => {
        const newCoins = coins + amount;
        setCoins(newCoins);
        localStorage.setItem('coins', newCoins);
    };

    const handleAddComCoins = (comamount) => {
        const newComCoins = comcoins + comamount;
        setComCoins(newComCoins);
        localStorage.setItem('comcoins', newComCoins);
    };

    const handleDropdownToggle = () => setIsDropdownVisible(!isDropdownVisible);
    const handleDropdownHide = () => setIsDropdownVisible(false);
    const handleToggle = () => setPanelVisible(!panelVisible);

    const dropdownStyle = { 
        display: isDropdownVisible ? 'block' : 'none', 
        position: 'absolute',
        top: '90%', 
        right: '0',
        backgroundColor: '#f9f9f9', 
        minWidth: '260px', 
        boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)', 
        padding: '10px',
        zIndex: 1200 
    };

    const mainStyle = {
      flex: 1,
      overflowY: 'auto',
      // display: isMobile ? "block" : "none",
    };

    return (
        <div style={layoutStyle}>
            <header style={headerStyle}>
                <div style={{ marginRight: '20px' }}>
                    {/* <p style={{ marginTop: '15px', fontSize:'16px', color:'#482BE7', fontWeight:'bold' }}>仙 Xianhe. ai</p>
                    <p style={{ marginTop: '-20px', fontSize:'16px', color:'#482BE7', fontWeight:'bold' }}>荷 Lotus Fairy. ai</p> */}

                    <img 
                                            src={xianheLogo} 
                                            alt="" 
                                            style={{ width: 'auto', height: '60px', marginRight: '10px', margineTop:'5px' }} 
                                        />
                </div>
                {/* <button
                    style={LocationBtn}
                    onMouseOver={(e) => e.currentTarget.style.borderColor = buttonHoverStyle.borderColor}
                    onMouseOut={(e) => e.currentTarget.style.borderColor = buttonStyle.border}
                >
                    <span style={smallTextStyle}>Deliver to </span>
                    <span style={largeTextStyle}>Singapore</span>
                </button>
                <div style={inputContainerStyle}>
                    <input type="text" placeholder="Search..." style={inputStyle} />
                    <FaSearch style={{ marginLeft: '10px', cursor: 'pointer' }} />
                </div> */}

                <div style={{
                  display: isMobile ? "none" : "block",
                  alignItems:'center', 
                  backgroundColor:'red', 
                  width:'85%',
                  // marginLeft: isMobile? "none" : "170px"
                  }}>
                  <TopBar/>
                </div>
                <button style={dropdownIconStyle} onClick={handleLogout}>Sign Out</button>
            </header>

            <main style={mainStyle}> 
            <div style={{display: isMobile ? "block" : "none",}}>
              <TopBar />
            </div>       

                <Outlet />
            </main>

        </div>
    );
};

const layoutStyle = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  width: '100vw',
  margin: 0,
  overflowX: 'hidden',
  position: 'relative',
  height: '100vh',
};

const headerStyle = {
  backgroundColor: '#f8f8f8',
  paddingLeft: '10px',
  display: 'flex',
  alignItems: 'center',
  paddingRight:'10px',
  height:'60px'
};

const inputContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  width: '60%',
};

const inputStyle = {
  width: '100%',
  minWidth:'50px',
  padding: '10px',
  borderRadius: '5px',
  border: '1px solid #ccc'
};

const buttonHoverStyle = {
  borderColor: '#007bff',
};

const smallTextStyle = {
  fontSize: '10px',
  lineHeight: '1',
  color: 'black',
};

const largeTextStyle = {
  fontSize: '12px',
  lineHeight: '1.2',
  fontWeight: 'bold',
  color: 'black',
};

const overallcontainer = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
};

const userBoxStyle = { 
  position: 'relative', 
  cursor: 'pointer', 
  // backgroundColor:'red',
  padding:'20px',
};

const iconContainerStyle = { 
  display: 'flex', 
  justifyContent: 'space-around', 
  marginTop: '10px' 
};

const coinsBoxStyle = {
  backgroundColor: '#f0f0f0',
  border: '1px solid #ddd',
  borderRadius: '5px',
  padding: '8px 12px',
  margin: '0 5px',
  textAlign: 'center',
  fontSize: '14px',
  fontWeight: 'bold',
  flex: '1',
  justifyContent:'center',
  alignContent:'center'
};


const dropdownIconStyle = {
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '5px',
    borderRadius: '50%',
    transition: 'background-color 0.3s ease, transform 0.3s ease',
    fontSize: '16px',
    color: '#333',
    fontWeight:'bold',
    position:'absolute',
    right:'30px'
  };
  
  const linkdropdownIconStyle = {
    ...dropdownIconStyle,
    color: '#333',
  };

const additionalContentStyle = { 
  display: 'flex', 
  justifyContent: 'space-between', 
  marginTop: '15px' 
};

const LocationBtn = {
  backgroundColor: '#ffffff',
  border: '1px solid #dcdcdc',
  padding: '5px 10px',
  borderRadius: '5px',
  cursor: 'pointer',
  marginRight:'15px'
};

const buttonStyle = {
  backgroundColor: '#ffffff',
  border: '1px solid #dcdcdc',
  padding: '5px 10px',
  borderRadius: '5px',
  cursor: 'pointer',
  color:'black'
};

const linkbuttonStyle = {
    backgroundColor: '#ffffff',
    border: '1px solid #dcdcdc',
    padding: '5px 10px',
    borderRadius: '5px',
    cursor: 'pointer',
    color:'black',
    fontSize:'16px',
    textDecoration:'none'
  };

export default MasterLayout;
